export enum AppointmentStatus {
  PENDING = 0,
  APPROVED = 1,
  CANCELED = -1,
}
